// src/actions/hdfcRetailUPActions.js
import axios from 'axios';
import {
    GET_ALL_HDFC_RETAIL_UP_REQUEST,
    GET_ALL_HDFC_RETAIL_UP_SUCCESS,
    GET_ALL_HDFC_RETAIL_UP_FAIL,
    IMPORT_HDFC_RETAIL_UP_REQUEST,
    IMPORT_HDFC_RETAIL_UP_SUCCESS,
    IMPORT_HDFC_RETAIL_UP_FAIL,
    EXPORT_HDFC_RETAIL_UP_REQUEST,
    EXPORT_HDFC_RETAIL_UP_SUCCESS,
    EXPORT_HDFC_RETAIL_UP_FAIL,
    UPDATE_HDFC_RETAIL_UP_REQUEST,
    UPDATE_HDFC_RETAIL_UP_SUCCESS,
    UPDATE_HDFC_RETAIL_UP_FAIL,
    DELETE_HDFC_RETAIL_UP_REQUEST,
    DELETE_HDFC_RETAIL_UP_SUCCESS,
    DELETE_HDFC_RETAIL_UP_FAIL,
    BULK_DELETE_HDFC_RETAIL_UP_REQUEST,
    BULK_DELETE_HDFC_RETAIL_UP_SUCCESS,
    BULK_DELETE_HDFC_RETAIL_UP_FAIL,
} from '../constants/hdfcRetailUPConstants';
import { logout } from './userActions';

const baseUrl = process.env.REACT_APP_API_URL;

// Get HDFC Retail UP records with pagination and search
export const getHdfcRetailUPRecords = (queryParams = '') => async (dispatch, getState) => {
    try {
        dispatch({ type: GET_ALL_HDFC_RETAIL_UP_REQUEST });

        const {
            userLogin: { userInfo },
        } = getState();

        // Parse and validate query parameters
        const params = new URLSearchParams(queryParams);
        const page = Math.max(1, parseInt(params.get('page')) || 1);
        const limit = Math.max(1, parseInt(params.get('limit')) || 10);
        const search = params.get('search') || '';
        const importDate = params.get('importDate') || '';
        const status = params.get('status') || '';
        const losLsMailFilter = params.get('losLsMailFilter') || '';
        const fosFilter = params.get('fosFilter') || '';
        const dept = params.get('dept') || '';

        // Rebuild clean query string
        let cleanQuery = `search=${encodeURIComponent(search)}&page=${page}&limit=${limit}`;
        if (importDate) {
            cleanQuery += `&importDate=${encodeURIComponent(importDate)}`;
        }
        if (status) {
            cleanQuery += `&status=${encodeURIComponent(status)}`;
        }
        if (losLsMailFilter) {
            cleanQuery += `&losLsMailFilter=${encodeURIComponent(losLsMailFilter)}`;
        }
        if (fosFilter) {
            cleanQuery += `&fosFilter=${encodeURIComponent(fosFilter)}`;
        }
        if (dept) {
            cleanQuery += `&dept=${encodeURIComponent(dept)}`;
        }

        console.log('HDFC Retail UP API Call with params:', { search, page, limit, importDate, status, losLsMailFilter, fosFilter, dept });

        const config = {
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${userInfo.token}`,
            },
        };

        const { data } = await axios.get(`${baseUrl}/hdfc-retail-up?${cleanQuery}`, config);

        dispatch({
            type: GET_ALL_HDFC_RETAIL_UP_SUCCESS,
            payload: data,
        });
    } catch (error) {
        if (error.response?.status === 401) {
            dispatch(logout());
            return;
        }
        dispatch({
            type: GET_ALL_HDFC_RETAIL_UP_FAIL,
            payload: error.response && error.response.data.message
                ? error.response.data.message
                : error.message,
        });
    }
};

// Import HDFC Retail UP records from file
export const importHdfcRetailUPRecords = (formData) => async (dispatch, getState) => {
    try {
        dispatch({ type: IMPORT_HDFC_RETAIL_UP_REQUEST });

        const {
            userLogin: { userInfo },
        } = getState();

        const config = {
            headers: {
                'Content-Type': 'multipart/form-data',
                Authorization: `Bearer ${userInfo.token}`,
            },
        };

        const { data } = await axios.post(`${baseUrl}/hdfc-retail-up/import`, formData, config);

        dispatch({
            type: IMPORT_HDFC_RETAIL_UP_SUCCESS,
            payload: data,
        });
    } catch (error) {
        if (error.response?.status === 401) {
            dispatch(logout());
            return;
        }
        dispatch({
            type: IMPORT_HDFC_RETAIL_UP_FAIL,
            payload: error.response && error.response.data.message
                ? error.response.data.message
                : error.message,
        });
    }
};

// Export HDFC Retail UP records to file
export const exportHdfcRetailUPRecords = () => async (dispatch, getState) => {
    try {
        dispatch({ type: EXPORT_HDFC_RETAIL_UP_REQUEST });

        const {
            userLogin: { userInfo },
        } = getState();

        const config = {
            headers: {
                Authorization: `Bearer ${userInfo.token}`,
            },
            responseType: 'blob',
        };

        const { data, headers } = await axios.get(`${baseUrl}/hdfc-retail-up/export`, config);

        // Try to get filename from content-disposition header
        let filename = 'HDFC_Retail_UP_Export.xlsx';
        const disposition = headers && headers['content-disposition'];
        if (disposition && disposition.indexOf('filename=') !== -1) {
            filename = disposition.split('filename=')[1].replace(/['"]/g, '');
        }

        // Create download link
        const url = window.URL.createObjectURL(new Blob([data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', filename);
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);

        dispatch({
            type: EXPORT_HDFC_RETAIL_UP_SUCCESS,
            payload: 'Export completed successfully',
        });
    } catch (error) {
        if (error.response?.status === 401) {
            dispatch(logout());
            return;
        }
        dispatch({
            type: EXPORT_HDFC_RETAIL_UP_FAIL,
            payload: error.response && error.response.data.message
                ? error.response.data.message
                : error.message,
        });
    }
};

// Update HDFC Retail UP record
export const updateHdfcRetailUPRecord = (id, recordData) => async (dispatch, getState) => {
    try {
        dispatch({ type: UPDATE_HDFC_RETAIL_UP_REQUEST });

        const {
            userLogin: { userInfo },
        } = getState();

        const config = {
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${userInfo.token}`,
            },
        };

        const { data } = await axios.put(`${baseUrl}/hdfc-retail-up/${id}`, recordData, config);

        dispatch({
            type: UPDATE_HDFC_RETAIL_UP_SUCCESS,
            payload: data,
        });
    } catch (error) {
        if (error.response?.status === 401) {
            dispatch(logout());
            return;
        }
        dispatch({
            type: UPDATE_HDFC_RETAIL_UP_FAIL,
            payload: error.response && error.response.data.message
                ? error.response.data.message
                : error.message,
        });
    }
};

// Delete HDFC Retail UP record
export const deleteHdfcRetailUPRecord = (id) => async (dispatch, getState) => {
    try {
        dispatch({ type: DELETE_HDFC_RETAIL_UP_REQUEST });

        const {
            userLogin: { userInfo },
        } = getState();

        const config = {
            headers: {
                Authorization: `Bearer ${userInfo.token}`,
            },
        };

        await axios.delete(`${baseUrl}/hdfc-retail-up/${id}`, config);

        dispatch({
            type: DELETE_HDFC_RETAIL_UP_SUCCESS,
            payload: id,
        });
    } catch (error) {
        if (error.response?.status === 401) {
            dispatch(logout());
            return;
        }
        dispatch({
            type: DELETE_HDFC_RETAIL_UP_FAIL,
            payload: error.response && error.response.data.message
                ? error.response.data.message
                : error.message,
        });
    }
};

// Bulk delete HDFC Retail UP records
export const bulkDeleteHdfcRetailUPRecords = (ids) => async (dispatch, getState) => {
    try {
        dispatch({ type: BULK_DELETE_HDFC_RETAIL_UP_REQUEST });

        const {
            userLogin: { userInfo },
        } = getState();

        const config = {
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${userInfo.token}`,
            },
        };

        const { data } = await axios.post(`${baseUrl}/hdfc-retail-up/bulk-delete`, { ids }, config);

        dispatch({
            type: BULK_DELETE_HDFC_RETAIL_UP_SUCCESS,
            payload: { deletedCount: data.deletedCount },
        });
    } catch (error) {
        if (error.response?.status === 401) {
            dispatch(logout());
            return;
        }
        dispatch({
            type: BULK_DELETE_HDFC_RETAIL_UP_FAIL,
            payload: error.response && error.response.data.message
                ? error.response.data.message
                : error.message,
        });
    }
};

// Sync HDFC Retail UP Task Status
export const syncHdfcRetailUPTaskStatus = () => async (dispatch, getState) => {
    try {
        dispatch({
            type: 'SYNC_HDFC_RETAIL_UP_TASK_STATUS_REQUEST',
        });

        const {
            userLogin: { userInfo },
        } = getState();

        const config = {
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${userInfo?.token}`,
            },
        };

        const { data } = await axios.post(
            `${baseUrl}/hdfc-retail-up/sync-status`,
            {},
            config
        );

        dispatch({
            type: 'SYNC_HDFC_RETAIL_UP_TASK_STATUS_SUCCESS',
            payload: data,
        });

        return data; // Return data including updatedRecords
    } catch (error) {
        if (error.response?.status === 401) {
            dispatch(logout());
            return;
        }
        dispatch({
            type: 'SYNC_HDFC_RETAIL_UP_TASK_STATUS_FAIL',
            payload:
                error.response && error.response.data.message
                    ? error.response.data.message
                    : error.message,
        });
        throw error;
    }
};

// Get Field Executives for HDFC Retail UP
export const getFieldExecutivesUP = (search = '') => async (dispatch, getState) => {
    try {
        dispatch({
            type: 'GET_FIELD_EXECUTIVES_UP_REQUEST',
        });

        const {
            userLogin: { userInfo },
        } = getState();

        const config = {
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${userInfo?.token}`,
            },
        };

        const { data } = await axios.get(
            `${baseUrl}/hdfc-retail-up/field-executives?search=${encodeURIComponent(search)}`,
            config
        );

        dispatch({
            type: 'GET_FIELD_EXECUTIVES_UP_SUCCESS',
            payload: data,
        });

        return data; // Return the data
    } catch (error) {
        if (error.response?.status === 401) {
            dispatch(logout());
            return;
        }
        dispatch({
            type: 'GET_FIELD_EXECUTIVES_UP_FAIL',
            payload:
                error.response && error.response.data.message
                    ? error.response.data.message
                    : error.message,
        });
        throw error; // Throw error so it can be caught
    }
};

export const getHdfcRetailUPFOS = (importDate = '') => async (dispatch, getState) => {
    try {
        dispatch({
            type: 'GET_FOS_UP_REQUEST',
        });

        const {
            userLogin: { userInfo },
        } = getState();

        const config = {
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${userInfo?.token}`,
            },
        };

        // Build URL with importDate query parameter if provided
        let url = `${baseUrl}/hdfc-retail-up/fos`;
        if (importDate) {
            url += `?importDate=${encodeURIComponent(importDate)}`;
        }

        const { data } = await axios.get(url, config);

        dispatch({
            type: 'GET_FOS_UP_SUCCESS',
            payload: data,
        });

        return data;
    } catch (error) {
        if (error.response?.status === 401) {
            dispatch(logout());
            return;
        }
        dispatch({
            type: 'GET_FOS_UP_FAIL',
            payload:
                error.response && error.response.data.message
                    ? error.response.data.message
                    : error.message,
        });
        throw error;
    }
};

export const getHdfcRetailUPDepartments = (importDate = '') => async (dispatch, getState) => {
    try {
        dispatch({
            type: 'GET_DEPARTMENTS_UP_REQUEST',
        });

        const {
            userLogin: { userInfo },
        } = getState();

        const config = {
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${userInfo?.token}`,
            },
        };

        // Build URL with importDate query parameter if provided
        let url = `${baseUrl}/hdfc-retail-up/departments`;
        if (importDate) {
            url += `?importDate=${encodeURIComponent(importDate)}`;
        }

        const { data } = await axios.get(url, config);

        dispatch({
            type: 'GET_DEPARTMENTS_UP_SUCCESS',
            payload: data,
        });

        return data;
    } catch (error) {
        if (error.response?.status === 401) {
            dispatch(logout());
            return;
        }
        dispatch({
            type: 'GET_DEPARTMENTS_UP_FAIL',
            payload:
                error.response && error.response.data.message
                    ? error.response.data.message
                    : error.message,
        });
        throw error;
    }
};